"use strict"

import _ from "lodash"
import angular from "angular"
import moment from "moment"

const kDateFormat = "YYYY-MM-DD"

angular
  .module("uCountitUiApp")

  .controller("ExportConfigCtrl", function ($scope, $uibModal, Auth, ExportConfigSrv) {
    Auth.fetchCurrentAccount().then((auth) => ($scope.auth = auth))
    $scope.errorMessage = ""
    $scope.serverTypes = [
      { value: "sftp", name: "SFTP" },
      { value: "ftp", name: "FTP" },
    ]

    $scope.showServerConfig = function (serverType) {
      return $scope.form.active && $scope.form.serverType.value === serverType
    }

    const getDefaultForm = function () {
      return {
        active: false,
        serverType: $scope.serverTypes[0],
        sftp: {
          host: "",
          port: 22,
          path: "",
          username: "",
          password: "",
        },
        ftp: {
          host: "",
          port: 21,
          path: "",
          username: "",
          password: "",
        },
      }
    }

    $scope.submitForm = function () {
      const form = _.cloneDeep($scope.form)
      form.serverType = form.serverType.value

      return ExportConfigSrv.Config.update({ id: $scope.selectedItem.id }, form).$promise.then(() =>
        $scope.onApply()
      )
    }

    const setDateTimePicker = function () {
      const options = {
        locale: { format: kDateFormat, applyLabel: "Download" },
        maxDate: moment().endOf("day"),
        autoUpdateInput: false,
        maxSpan: { months: 1 },
      }

      const element = $('#export-config input[name="log-button"]')

      element.daterangepicker2(options)

      element.on("apply.daterangepicker", async (ev, picker) => {
        let logs = []
        for (let m = moment(picker.startDate); m.isBefore(picker.endDate); m.add(1, "days")) {
          logs = [
            ...logs,
            ...(await ExportConfigSrv.Log.get({
              id: $scope.selectedItem._id,
              date: m.toISOString(),
            }).$promise),
          ]
        }

        const logString = logs
          .map((log) => `${log.createdAt} ${log.level.toUpperCase()} ${log.message}`)
          .join("\n")

        console.log(logString)

        const blob = new Blob([logString], { type: "text/plain;charset=utf-8" })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement("a")
        a.href = url
        a.download = `export_${$scope.selectedItem.name}_build_log(${picker.startDate.format(
          kDateFormat
        )}~${picker.endDate.format(kDateFormat)}).log`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(url)
      })
    }

    const init = function (item) {
      setDateTimePicker()
      $scope.form = null
      const defaultForm = getDefaultForm()
      if (!item) {
        $scope.form = defaultForm
        return
      } else {
        $scope.form = defaultForm
        ExportConfigSrv.Config.get({ id: item._id }, function (config) {
          const { serverType, ...exportConfig } = config

          defaultForm.serverType =
            _.find($scope.serverTypes, { value: serverType }) || $scope.serverTypes[0]

          $scope.form = _.merge(defaultForm, exportConfig)
        })
      }
    }

    return $scope.$watch("selectedItem", function (item) {
      return init(item)
    })
  })
